(function () {
    // Allow click anywhere on the search result to go to the page, not just the title link
    document.addEventListener("click", function (e) {
        const gscResult = e.target.closest(".gsc-result")
        if (gscResult) {
            const link = gscResult.querySelector("a.gs-title")
            if (link && link.href) {
                window.location = link.href;
            }
        }
    })
})();